export default "__VITE_ASSET__Dk8Lru4r__"